<form [formGroup]="parent" class="logintab" (ngSubmit)="loginClick()">
    <mat-expansion-panel class="mat-elevation-z0" [hideToggle]="true" [expanded]="foersteGangAktiveret">
        <div formGroupName="forbrugerNrGroup">
            <div>Indtast dit eksisterende login</div>
            <div>
                <a href="javascript:void(0);" (click)="loginHjaelpClick()">Hvor finder jeg mine loginoplysninger?</a>
            </div>
            <div>
                <mat-form-field fxLayout="column">
                    <input matInput placeholder="Forbrugernummer" formControlName="forbrugerNr" type="number" id="forbrugernr" required />
                </mat-form-field>
            </div>
            <div>
                <mat-form-field fxLayout="column">
                    <input matInput placeholder="Kode (4 cifre)" formControlName="kode" type="password" id="kode" required />
                </mat-form-field>
            </div>
        </div>
    </mat-expansion-panel>

    <div formGroupName="emailGroup" class="login-group-wrapper">
        @if (foersteGangAktiveret) {
            <div>Indtast din e-mail og ønskede adgangskode</div>
        }
        <div>
            <mat-form-field fxLayout="column">
                <input matInput #emailInput placeholder="E-mail" formControlName="email" type="email" id="email" required />
                @if (parent.get("emailGroup.email").errors && visFeltFejl) {
                    <mat-error>Indtast gyldig e-mail</mat-error>
                }
            </mat-form-field>
        </div>
        <div [hidden]="glemtKodeordAktiveret">
            <mat-form-field fxLayout="column">
                <input matInput placeholder="Adgangskode" formControlName="adgangskode" type="password" id="adgangskode" required />
            </mat-form-field>
        </div>
    </div>
    <div [hidden]="glemtKodeordAktiveret">
        <mat-checkbox formControlName="huskMig" id="huskmig">Husk mig</mat-checkbox>
    </div>
    @if (infoBesked) {
        <div>
            {{ infoBesked }}
        </div>
    }
    @if (fejlBesked) {
        <div class="fejlBesked">
            {{ fejlBesked }}
        </div>
    }

    @if (!foersteGangAktiveret && !glemtKodeordAktiveret) {
        <div>
            <div fxLayoutAlign="end start">
                <button type="submit" mat-flat-button color="primary" id="login">Log ind</button>
            </div>
            <div class="linkMargin">
                <a href="javascript:void(0);" (click)="onGlemtKodeordClick()">Har du glemt din adgangskode?</a>
            </div>
            <div>
                <a href="javascript:void(0);" (click)="firstTimeClick()">Er det første gang du logger ind med e-mail?</a>
            </div>
            <!--div>
      <a href="javascript:void(0);" (click)="firstTimeClick()">Ønsker du at samle flere logins?</a>
    </div-->
        </div>
    } @else {
        @if (!glemtKodeordAktiveret) {
            <div>
                <div fxLayoutAlign="end start">
                    <button mat-button color="primary" (click)="firstTimeClick()">Fortryd</button>
                    <button mat-flat-button color="primary" type="submit" id="opretLogin">Opret login</button>
                </div>
            </div>
        } @else {
            <div fxLayoutAlign="end start">
                @if (!infoBesked) {
                    <div>
                        <button mat-button type="button" color="primary" (click)="onGlemtKodeordClick()">Fortryd</button>
                        <button mat-flat-button color="primary" type="submit" id="sendEmail">Send mig en e-mail</button>
                    </div>
                }
                @if (infoBesked) {
                    <div>
                        <button mat-flat-button color="primary" (click)="onGlemtKodeordClick()">Tilbage til login</button>
                    </div>
                }
            </div>
        }
    }
</form>
